export default {
  getRelatorioChamadas: state => state.chamadas,
  getCentroDeCustos: state => state.centroDeCustos,
  getTags: state => state.tags,
  getDadosRelatorio: state => state.dadosRelatorio,
  getDescriptionSpecificConferencia: state => id => {
    const indexConferencia = state.conferencias.findIndex(conferencia => conferencia._id === id)
    return state.conferencias[indexConferencia].description
  },
}
